﻿export const vi = {
  apply: "Áp dụng",
  cart_is_empty: "Giỏ hàng của bạn đang trống. Tìm sản phẩm để thêm vào giỏ hàng",
  browse_products: "Xem các sản phẩm",
  invalid_coupon: "Bạn đã nhập mã khuyến mại không hợp lệ. Vui lòng kiểm tra mã và thử lại.",
  duplicate_coupon: "Mã giảm giá {{couponInputValue}} đã được áp dụng",
  products: "Sản phẩm",
  product: "Sản phẩm",
  qty: "SL",
  price: "Giá tiền",
  remove: "Xóa",
  add_to_cart: "Thêm vào giỏ hàng",
  show_more: "Hiển thị thêm",
  show_less: "Hiển thị ít hơn",
  order_summary: "Tóm tắt đơn hàng",
  your_cart: "Giỏ hàng của bạn",
  item: "món hàng",
  items: "món hàng",
  enter_discount_code: "Nhập mã giảm giá",
  continue_shopping: "Tiếp tục mua sắm",
  i_agree: "Bằng cách tiếp tục, tôi đồng ý rằng tôi đã đọc và chấp nhận",
  privacy_policy: "Chính sách quyền riêng tư",
  refund_policy: "Chính sách hoàn tiền",
  terms_of_use: "Điều khoản sử dụng",
  and: "và",
  total: "Tổng",
  exclude: "Loại trừ",
  include: "Bao gồm",
  tax: "Thuế",
  subtotal: "Tổng phụ",
  discount: "Giảm giá",
  coupon_discount: "Phiếu giảm giá",
  checkout: "Thanh toán"
};